export const de = {
    translation: {
        errorCodes: {
            PARSE_ERROR: 'Konnte nicht analysiert werden',
            BAD_REQUEST: 'Ungültige Anfrage',
            INTERNAL_SERVER_ERROR: 'Unerwarteter Serverfehler',
            NOT_IMPLEMENTED: 'Nicht implementiert',
            UNAUTHORIZED: 'Kein gültiger Administrator',
            FORBIDDEN: 'Zugriff verboten',
            NOT_FOUND: 'Nicht gefunden',
            METHOD_NOT_SUPPORTED: 'Diese Methode wird nicht unterstützt',
            TIMEOUT: 'Zeitüberschreitung aufgetreten',
            CONFLICT: 'Ein Konflikt ist aufgetreten',
            PRECONDITION_FAILED: 'Eine Vorbedingung ist fehlgeschlagen',
            PAYLOAD_TOO_LARGE: 'Die Nutzlast ist zu groß',
            UNPROCESSABLE_CONTENT: 'Die Daten können nicht verarbeitet werden',
            TOO_MANY_REQUESTS: 'Zu viele Anfragen',
            CLIENT_CLOSED_REQUEST: 'Der Client hat die Anfrage geschlossen',
        },
        actions: {
            ok: 'OK',
            yes: 'Ja',
            no: 'Nein',
            help: 'Hilfe',
            back: 'Zurück',
            next: 'Weiter',
            create: 'Erstellen',
            createNamed: '{{name}}\xa0erstellen',
            save: 'Speichern',
            saveChanges: 'Änderungen\xa0speichern',
            saveDraft: 'Entwurf\xa0speichern',
            cancel: 'Abbrechen',
            close: 'Schließen',
            edit: 'Bearbeiten',
            editSettings: 'Einstellungen\xa0bearbeiten',
            delete: 'Löschen',
            remove: 'Entfernen',
            discardChanges: 'Änderungen verwerfen',
            assign: 'Zuweisen',
            print: 'Drucken',
            download: 'Herunterladen',
            share: 'Teilen',
            send: 'Senden',
            import: 'Importieren',
            export: 'Exportieren',
            archive: 'Archivieren',
            unarchive: 'Unarchivieren',
            preview: 'Vorschau',
            view: 'Anzeigen',
            clear: 'Leeren',
            apply: 'Übernehmen',
            submit: 'Abschicken',
            copyToClipboard: 'In Zwischenablage kopieren',
            useUserTimezone: 'Meine Zeitzone verwenden',
            applyFilter: 'Filter\xa0anwenden',
            clearFilter: 'Filter\xa0löschen',
            loadMore: 'Mehr laden',
            more: 'Mehr',
        },
        misc: {
            sortedBy: 'sortiert nach',
            sortAscending: 'Aufsteigend sortieren',
            sortDescending: 'Absteigend sortieren',
            today: 'Heute',
            calendarWeek: 'KW',
            copiedToClipboard: 'In die Zwischenablage kopiert',
            tagsEdit: 'Tippen, um Tags hinzuzufügen',
            tagsReadOnly: 'Keine Tags verfügbar',
            required: 'Erforderlich',
            optional: 'Optional',
        },
        components: {
            form: {
                submitError: 'Beim Absenden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
                submitSuccess: 'Änderungen erfolgreich gespeichert',
                deleteError: 'Beim Löschen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
                deleteSuccess: 'Erfolgreich gelöscht',
            },
            markdownToolbar: {
                bold: 'Fett',
                italic: 'Kursiv',
                strikeThrough: 'Durchgestrichen',
                highlight: 'Hervorheben',
                heading: 'Überschrift {{level}}',
                unorderedList: 'Aufzählungszeichen',
                orderedList: 'Liste',
                divider: 'Trennlinie',
                link: 'Link',
                image: 'Bild',
                file: 'Datei',
                quote: 'Zitat',
            },
            useUpload: {
                fileTooLarge: {
                    title: 'Datei zu groß',
                    message: 'Die angegebene Datei ist zu groß zum Hochladen',
                },
                uploadError: {
                    title: 'Hochladen fehlgeschlagen',
                    message: 'Beim Hochladen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
                },
                progress: 'Datei wird hochgeladen ({{progress}}%)...',
            },
        },
    },
}
